<ng-container *ngIf="icon">
    <span class="drg-icon" [ngClass]="icon"></span>
</ng-container>
<ng-content></ng-content>
